<div (click)="$event.stopImmediatePropagation()" *ngIf="listItems && listItems.length">
  <div class="ellipsis">
    <button
      [title]="
        (params.data.requestContent
          ? 'broadcast.broadcastHistoryList.previewRequest'
          : 'broadcast.broadcastHistoryList.noPreviewAvailable'
        ) | translate
      "
      [disabled]="!params.data.requestContent"
      nz-button
      nzType="link"
      (click)="emitAction()"
    >
      {{
        (params.data.requestContent
          ? 'broadcast.broadcastHistoryList.previewRequest'
          : 'broadcast.broadcastHistoryList.noPreviewAvailable'
        ) | translate
      }}
    </button>
  </div>
</div>
